import { Component, ViewChild, ElementRef } from '@angular/core';
import { NavController, NavParams, Content, AlertController, Platform, ViewController, ToastController, ActionSheetController } from 'ionic-angular';
import { PhotoLibrary } from '../../../../providers/my-photo-library';
import { PhotoAction, _PhotoAction } from '../../../../actions/photo.action';
import { PhotoViewer } from '@ionic-native/photo-viewer';
import { CallNumber } from '@ionic-native/call-number';
import { AbstractPage } from '../../../_com/abstract-page';
import { ChatAction } from '../../../../actions/chat.action';
import { ReserveAction } from '../../../../actions/reserve.action';
import { Subscription } from 'rxjs';

/**
 * Generated class for the InterviewSheetEditStaffPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: "page-notebook-edit",
  templateUrl: "notebook-edit.html",
})
export class NotebookEditPage extends AbstractPage {
  // 子供情報
  // - サンプル
  // {"Child":{"familyId":"61127004a63367be6a543a9e","newChild":false,"name":"太郎","kana":"たろう","gender":"boy","birthday":"2016-03-23T15:00:00.000Z","takuji_keiken_status":"true","allergy_status":"true","sikkan":"true","junyu_status":"false","modified_user":"5ad6ab64a63367582f40221c","modified":"2022-Feb-13 09:36:16","created":"2021-Aug-10 21:25:03","tabetakotoaru_foods":["3","4","5"],"keijyo_yasai":"3","rinyushoku_shokuzai":["jagaimo","ninjin","aona","tamanegi","kyabetsu"],"rinyushoku_tabetakotoaru_shokuzai":["jagaimo","ninjin","aona","kyabetsu","shoyu"],"rinyusyoku_okayu":"5","syokuji_ryo":"2","syokuji_kininaru_tabemura":true,"syokuji_kininaru_asobitabe":true,"seikatsu_rizumu_kisho":"2021-09-26T03:00:00.000Z","sanpo_sanka_status":"true","allergy_text":"2/10 あいうえお","sikkan_sonota_text":"2/10 かきくけこ","konamiruku_text":"2/10 さしすせそ","id":"61127020a63367c06a543a94"}}
  child: any = {};

  familyId: string;
  reserveId: string;
  reserveDate: string;
  reserveTime: string;

  notebookId = ""; // 問診票IDを格納
  notebook: any = {};

  notebookInfo: {
    taichou: string;
    kega: string;
    other: string;
    taichou_pictures: any[],
    kega_pictures: any[],
  } = {
    taichou: "",
    kega: "",
    other: "",
    taichou_pictures: [],
    kega_pictures: []
  };

  photoAction: _PhotoAction;
  captureData$: Subscription;
  captureDatas$: Subscription;

  @ViewChild(Content) content: Content;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public chatAction: ChatAction,
    public reserveAction: ReserveAction,
    private pv: PhotoViewer,
    private pl: PhotoLibrary,
    private alertController: AlertController,
    private toastController: ToastController,
    private plt: Platform,
    private callNumber: CallNumber,
    public viewController: ViewController,
    private el: ElementRef,
    private actionSheetController: ActionSheetController,
    public tmpPhotoAction: PhotoAction,

  ) {
    super();

    this.photoAction = tmpPhotoAction.getInstance();
    this.takePictureDataSubscribe();

    this.familyId = this.navParams.data.familyId;
    this.reserveId = this.navParams.data.reserveId;
    this.reserveDate = this.navParams.data.reserveDate;
    this.reserveTime = this.navParams.data.reserveTime;

    // 予約詳細からきた場合
    this.child = this.navParams.data.child.Child;
    this.notebookInfo = this.navParams.data.notebookInfo || {}; // 問診票情報
    this.notebookId = this.navParams.data.notebookId || ""; // 問診票ID

    this.pl; //for TSLint
    this.pv; //for TSLint
    this.plt; //for TSLint
    this.callNumber; //for TSLint

    super.readyDomAccess(this.el);
  }

  /**
   * 画面が呼び出される前にロード
   */
  ionViewDidLoad() {
    // 受け取った値をセットする
    this.reserveAction
      .getNotebookData({
        reserveId: this.reserveId,
        childId: this.child["id"],
      })
      .subscribe((res) => {
        // ここでデータを取得する
        if (res.data.length > 0) {
          // データ画面に反映
          this.notebook = res.data[0]["Notebook"];
          this.notebookInfo = res.data[0]["Notebook"]["notebookInfo"];
          this.notebookId = res.data[0]["Notebook"]["id"];
        }
      });
  }

  /**
   * subscription破棄
   */
  ngOnDestroy() {
    this.captureData$.unsubscribe();
    this.captureDatas$.unsubscribe();
    this.photoAction = null;
  }



  /**
   * キャンセル処理
   */
  cancel() {
    //入力項目タッチ無し
    if (!this.hasTouched()) {
      this.viewController.dismiss();
      return;
    }

    //入力項目タッチありで、画面を閉じる
    this.confirm(
      this.alertController,
      "画面を閉じます。よろしいですか？",
      () => {
        this.viewController.dismiss();
      }
    );
  }

  /**
   * 問診票情報保存
   */
  save() {
    // 必須チェック
    if (this.hasInvalidRequired()) {
      this.alert(
        this.alertController,
        "未入力の項目を確認してください。（" +
          this._el.querySelectorAll(".requiredError").length +
          "箇所）"
      );
      return;
    }

    // api側に送るデータを定義
    const data = {
      id: (this.notebookId) ? this.notebookId : "",
      familyId: this.familyId,
      childId: this.child.id,
      // 予約ID
      reserveId: this.reserveId,
      // 予約日
      reserveDate: this.reserveDate,
      // 予約時間
      reserveTime: this.reserveTime,
      notebookInfo: this.notebookInfo,
    };

    // 予約日
    if (!data.reserveDate && this.notebook?.reserveDate) {
      data.reserveDate = this.notebook.reserveDate;
    }
    // 予約時間
    if (!data.reserveTime && this.notebook?.reserveTime) {
      data.reserveTime = this.notebook.reserveTime;
    }

    // 登録
    this.confirm(
      this.alertController,
      "入力された内容で体調不良・怪我連絡を送信します。よろしいですか？",
      () => {
        this.reserveAction.saveNotebook(data).subscribe((data) => {
          this.toast(this.toastController, "体調不良・怪我連絡を登録しました。");
          this.navCtrl.pop();
        }, (e) => {
          console.log(e);
        })
      }
    );
  }


  /**
   * 写真データ取得時イベント
   */
  private takePictureDataSubscribe() {
    var self = this;

    /* カメラ撮影(1数) */
    this.captureDatas$ = this.photoAction.captureDatas$.subscribe(
      (imageDatas) => {
        if (self.photoAction.getScreen() === "taichou") {
          this.selectedTaichouPicture(imageDatas);
        } else if (self.photoAction.getScreen() === "kega") {
          this.selectedKegaPicture(imageDatas);
        }
      }
    );

    /* 写真選択(複数枚) */
    this.captureData$ = this.photoAction.captureData$.subscribe((imageData) => {
      if (self.photoAction.getScreen() === "taichou") {
        this.selectedTaichouPicture([imageData]);
      } else if (self.photoAction.getScreen() === "kega") {
        this.selectedKegaPicture([imageData]);
      }

    });
  }

  taichoukanriTakePicture() {
    let actionSheet = this.actionSheetController.create({
      title: "選択してください",
      buttons: [
        {
          text: "写真を撮影する",
          handler: () => {
            this.photoAction.takeCamera({ needModal: true, screen: "taichou" });
          },
        },
        {
          text: "アルバムから選択する",
          handler: () => {
            this.photoAction.photoSelectMultiple({ needModal: true, screen: "taichou" });
          },
        },
        {
          text: "キャンセル",
          role: "cancel",
        },
      ],
    });
    actionSheet.present();
  }
  selectedTaichouPicture(imageDatas: any) {
    console.log(imageDatas);

    // 問診票に画像を保存する
    if (!this.notebookInfo.taichou_pictures) {
      this.notebookInfo.taichou_pictures = [];
    }
    if (Array.isArray(imageDatas)) {
      for (const image of imageDatas) {
        this.notebookInfo.taichou_pictures.push(image);
      }
    } else {
      this.notebookInfo.taichou_pictures.push(imageDatas);
    }
  }
  removeTaichouPicture(index) {
    this.confirm(this.alertController, "削除します。よろしいですか？", () => {
      this.notebookInfo.taichou_pictures = this.notebookInfo.taichou_pictures.filter((image, i) => {
        return `${index}` !== `${i}`;
      });
    });
  }


  kegaTakePicture() {
    let actionSheet = this.actionSheetController.create({
      title: "選択してください",
      buttons: [
        {
          text: "写真を撮影する",
          handler: () => {
            this.photoAction.takeCamera({ needModal: true, screen: "kega" });
          },
        },
        {
          text: "アルバムから選択する",
          handler: () => {
            this.photoAction.photoSelectMultiple({ needModal: true, screen: "kega" });
          },
        },
        {
          text: "キャンセル",
          role: "cancel",
        },
      ],
    });
    actionSheet.present();
  }
  selectedKegaPicture(imageDatas: any) {
    console.log(imageDatas);

    // 問診票に画像を保存する
    if (!this.notebookInfo.kega_pictures) {
      this.notebookInfo.kega_pictures = [];
    }

    if (Array.isArray(imageDatas)) {
      for (const image of imageDatas) {
        this.notebookInfo.kega_pictures.push(image);
      }
    } else {
      this.notebookInfo.kega_pictures.push(imageDatas);
    }
  }
  removeKegaPicture(index) {
    this.confirm(this.alertController, "削除します。よろしいですか？", () => {
      this.notebookInfo.kega_pictures = this.notebookInfo.kega_pictures.filter((image, i) => {
        return `${index}` !== `${i}`;
      });
    });
  }




}



// WEBPACK FOOTER //
// ./src/pages/reserve/noteboook/notebook-edit/notebook-edit.ts